import { render, staticRenderFns } from "./ChartOrdersByDayForWarehouseItem.vue?vue&type=template&id=60690f74"
import script from "./ChartOrdersByDayForWarehouseItem.vue?vue&type=script&lang=js"
export * from "./ChartOrdersByDayForWarehouseItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports